import angular from 'angular';
import booksData from '../../data/BooksData';
/** Add Change Item Dialog */
import {
  AddChangeItemDialogProvider,
  AddChangeItemDialogContentDirective
} from './AddChangeItemDialog';
/** Add Change Item Discount Dialog */
import {
  addChangeDiscountDialogComponent,
  AddChangeItemDiscountDialogService
} from './AddChangeItemDiscountDialog';
/** Add Change Item Option Dialog */
import { AddChangeItemOptionDialogService } from './AddChangeItemOptionDialog';
/** Item Sale Limiter Dialog */
import { ItemSaleLimiterDialogService } from './ItemSaleLimiterDialog';
/** Manage Distributions Dialog */
import { ManageDistributionsDialogProvider } from './ManageDistributionsDialog';
/** Select Item Type Dialog */
import { SelectItemTypeDialogService } from './selectItemTypeDialog';
/** Basic Info */
import { basicInfoItemContentComponent } from './dom/basicInfo';
/** Discount */
import {
  ItemDiscountsContentDirective,
  ItemDiscountsControllerServiceProvider
} from './dom/discounts';
/** Inventory */
import {
  itemInventoryContentComponent,
  ItemInventoryController
} from './dom/inventory';
/** Options */
import { itemOptionsContentComponent } from './dom/options';
/** Sales Info */
import { salesInfoItemContentComponent } from './dom/salesInfo';
/** Sub Items */
import { subItemsContentComponent, SubItemsController } from './dom/subItems';
/** Tags */
import { itemTagsContentComponent, ItemTagsController } from './dom/tags';

export default angular
  .module('csm.books.com.AddChangeItem', [
    booksData,
    'ui.grid',
    'ui.grid.autoResize'
  ])
  .provider('AddChangeItemConfig', AddChangeItemConfigProvider)
  /** Select Item Type Dialog */
  .service('SelectItemTypeDialog', SelectItemTypeDialogService)
  /** Add Change Item Dialog */
  .provider('AddChangeItemDialog', AddChangeItemDialogProvider)
  .directive('addChangeItemDialogContent', AddChangeItemDialogContentDirective)
  /** Basic Info */
  .component('basicInfoItemContent', basicInfoItemContentComponent)
  /** Discount */
  .directive('itemDiscountsContent', ItemDiscountsContentDirective)
  .provider(
    'ItemDiscountsControllerService',
    ItemDiscountsControllerServiceProvider
  )
  /** Inventory */
  .component('itemInventoryContent', itemInventoryContentComponent)
  .controller('ItemInventoryController', ItemInventoryController)
  /** Options */
  .component('itemOptionsContent', itemOptionsContentComponent)
  /** Sales Info */
  .component('salesInfoItemContent', salesInfoItemContentComponent)
  /** Sub Items */
  .component('subItemsContent', subItemsContentComponent)
  .controller('SubItemsController', SubItemsController)
  /** Tags */
  .component('itemTagsContent', itemTagsContentComponent)
  .controller('ItemTagsController', ItemTagsController)
  /** Item Sale Limiter Dialog */
  .service('ItemSaleLimiterDialog', ItemSaleLimiterDialogService)
  /** Manage Distributions Dialog */
  .provider('ManageDistributionsDialog', ManageDistributionsDialogProvider)
  /** Add Change Item Option Dialog */
  .service('AddChangeItemOptionDialog', AddChangeItemOptionDialogService)
  /** Add Change Item Discount Dialog */
  .component(
    'addChangeDiscountDialogComponent',
    addChangeDiscountDialogComponent
  )
  .service('AddChangeItemDiscountDialog', AddChangeItemDiscountDialogService)
  .name;

/*******************************************************************************
 * @ngdoc  provider
 * @name   csm.books.com.AddChangeItem.provider:AddChangeItemConfig
 * @description
 * Configuration properties for module AddChangeItem. This contains the default
 * templates to use for the dialog tabs.
 *******************************************************************************/
/* @ngInject */ function AddChangeItemConfigProvider() {
  this.templateIDs = {
    BasicInfoTab: 'acidBasicInfo.template.html',
    SalesInfoTab: 'acidSalesInfo.template.html',
    SubItemsTab: 'acidSubItems.template.html',
    OptionsTab: 'acidOptions.template.html',
    InventoryTab: 'acidInventory.template.html',
    DiscountsTab: 'acidDiscounts.template.html',
    TagsTab: 'acidTags.template.html',
    AddDiscountDialog: 'acidAddDiscount.template.html'
  };

  /**
   * In AngularJS, providers are used to configure services during the configuration phase of
   * the application. The $templateCache service is not directly available in the provider's
   * constructor function. Instead, you can use the $templateCache service within the $get
   * method of the provider, which is executed during the runtime phase.
   */
  this.$get = [
    '$templateCache',
    function ($templateCache) {
      $templateCache.put(
        'acidBasicInfo.template.html',
        '<basic-info-item-content></basic-info-item-content>'
      );
      $templateCache.put(
        'acidSalesInfo.template.html',
        '<sales-info-item-content></sales-info-item-content>'
      );
      $templateCache.put(
        'acidSubItems.template.html',
        '<sub-items-content></sub-items-content>'
      );
      $templateCache.put(
        'acidOptions.template.html',
        '<item-options-content></item-options-content>'
      );
      $templateCache.put(
        'acidInventory.template.html',
        '<item-inventory-content></item-inventory-content>'
      );
      $templateCache.put(
        'acidDiscounts.template.html',
        '<item-discounts-content></item-discounts-content>'
      );
      $templateCache.put(
        'acidTags.template.html',
        '<item-tags-content></item-tags-content>'
      );
      $templateCache.put(
        'acidAddDiscount.template.html',
        '<add-change-discount-dialog-component></add-change-discount-dialog-component>'
      );

      return {
        templateIDs: this.templateIDs
      };
    }
  ];
}
